import type {RebaseState} from '../../../hooks/mutations/use-stack-rebase-mutation'
import {RebaseFailedIcon} from './rebase-state-icons/RebaseFailedIcon'
import {MergeConflictsIcon} from './rebase-state-icons/MergeConflictsIcon'
import {RebasedIcon} from './rebase-state-icons/RebasedIcon'
import {RebasingIcon} from './rebase-state-icons/RebasingIcon'
import {SkippedIcon} from './rebase-state-icons/SkippedIcon'

export function RebaseStateIcon(props: {state?: RebaseState}) {
  return (
    <>
      <RebasingIcon {...props} />
      <RebasedIcon {...props} />
      <MergeConflictsIcon {...props} />
      <RebaseFailedIcon {...props} />
      <SkippedIcon {...props} />
    </>
  )
}
